<script>
export default {
  server:'https://gky.kanekena.online/api/v2',
//  server:'http://10.0.0.2:57743/api/v2',
};
</script>
